<template>
  <div class="chat">
    <!--顶部-->
    <div class="head">
      <img @click="back" class="back" src="@/assets/images/back.png" />
      <div class="text">
        客服聊天
      </div>
    </div>
    <van-list
      class="msg"
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getMsgList"
      :immediate-check="false"
      direction="up"
    >
      <!--聊天消息框-->
      <div class="item" v-for="(item, index) in msgList" :key="index">
        <div class="rt" v-if="item.from === 'from-user'">
          <div class="zw"></div>
          <div class="right">
            <div class="time">
              {{ item.time }}
            </div>
            <div class="text" v-if="item.type === 'chat-text'">
              {{ item.content }}
            </div>
            <div v-if="item.type === 'chat-pic'">
              <img style="width: 180px;" :src="item.content" />
            </div>
          </div>
          <img
            class="tx"
            src="https://up1.53kf.com/kf/2021/4/26/16193997908560.jpg"
          />
        </div>

        <div class="left" v-else>
          <div class="tx">
            <img class="kefu-tx" src="@/assets/images/kefu.png" />
          </div>
          <div class="right">
            <div class="time">
              {{ item.time }}
            </div>
            <div class="text" v-if="item.type === 'chat-text'">
              {{ item.content }}
            </div>
            <div v-if="item.type === 'chat-pic'">
              <img style="width: 180px;" :src="item.content" />
            </div>
          </div>
          <div class="zw"></div>
        </div>
      </div>
    </van-list>

    <div
      class="input"
      style="padding: 7px 11px; border-bottom: 1px solid #ffffff;"
    >
      <img
        class="bq"
        src="@/assets/images/bq.png"
        @click="emojShow = !emojShow"
      />
      <div class="wj">
        <img class="wj-img" id="selectfiles" src="@/assets/images/wj.png" />
      </div>
      <img class="dz" src="@/assets/images/dz.png" />
    </div>
    <div class="input" style="padding: 0 15px;">
      <div class="sr">
        <van-field
          size="15px"
          @click-input="clickInput"
          :readonly="readonly"
          id="input"
          v-model="message"
          autosize
          border
          type="textarea"
          placeholder="请输入文字"
          autofocus
        />
      </div>
      <div class="btn" @click="sendMsg">
        发送
      </div>
    </div>
    <!--聊天输入框-->
    <VEmojiPicker @select="selectEmoji" v-show="emojShow" />
  </div>
</template>
<script>
import {
  kefu_api_online,
  kefu_api_text,
  get_chat_log,
  kefu_api_offline,
  authPolicy,
  sendPic
} from "@api/chat";
import dayjs from "dayjs";
import localforage from "localforage";
import plupload from "plupload";
import $store from "@/store";

export default {
  name: "chat",
  //mixins: [sendVerifyCode],

  data: function() {
    return {
      ossToken: {},
      websocket: null,
      message: "",
      emojShow: false,
      readonly: false,
      msgList: [],
      page: 1,
      error: false,
      loading: false,
      finished: false,
      interval: null,
      accessid: "",
      host: "",
      policyBase64: "",
      signature: "",
      callbackbody: "",
      key: "",
      expire: 0,
      g_object_name: "",
      uploader: "",
      picUrl: ""
    };
  },
  created() {
    this.getMsgList();
    this.initWebSocket();
    // group_auth_policy().then(res => {
    //   console.log("获取阿里云配置成功", res.data.data);
    //   vm.ossToken = res.data.data
    //   // var client = new OSS(res.data.data)  //后端提供数据
    // });
  },
  mounted() {
    //this.initWebSocket();
    const _this = this;
    this.uploader = new plupload.Uploader({
      runtimes: "html5,flash,silverlight,html4",
      flash_swf_url: "../libs/plupload-2.1.2/js/Moxie.swf",
      browse_button: "selectfiles",
      silverlight_xap_url: "../libs/plupload-2.1.2/js/Moxie.xap",
      url: "http://oss.aliyuncs.com",
      filters: {
        mime_types: [{ title: "Image files", extensions: "jpg,gif,png,bmp" }],
        max_file_size: "10mb", //最大只能上传10mb的文件
        prevent_duplicates: true //不允许选取重复文件
      },
      init: {
        FilesAdded: function(up, files) {
          console.log("发送图片1")
          console.log(up);
          console.log(files);
          _this.set_upload_param(up, files[0].name);
        },
        FileUploaded: function(up, file, info) {
          console.log("发送图片2")
          console.log(info)
          if (info.status === 200) {
            sendPic({
              content:
                "https://yiya-kefu.oss-accelerate.aliyuncs.com/" +
                _this.g_object_name
            }).then(async (sss) => {
              console.log("发送图片3")
              console.log(sss)
              _this.picUrl =
                "https://yiya-kefu.oss-accelerate.aliyuncs.com/" +
                _this.g_object_name;

              _this.msgList.push({
                from: "from-user",
                time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
                type: "chat-pic",
                content: _this.picUrl
              });
              console.log(_this.msgList);
              _this.scrollToBottom();
              await localforage.setItem("chat-log", this.msgList);
              await localforage.setItem(
                "chat-log-update",
                new Date().getTime()
              );
              _this.websocketSend(
                JSON.stringify({
                  type: "chat-pic",
                  content: _this.picUrl
                })
              );
            });
          } else if (info.status === 203) {
            
            console.log(info);
          } else {
            console.log(info);
          }
        },
        Error: function(up, err) {
          if (err.code === -600) {
            _this.$message({
              message: "图片太大了，请重新选择图片，大小不超过10mb",
              type: "warning"
            });
          } else if (err.code === -601) {
            _this.$message({
              message: "图片格式错误，支持：jpg,gif,png,bmp",
              type: "warning"
            });
          } else if (err.code === -602) {
            _this.$message({
              message: "这个文件已经上传过一遍了",
              type: "warning"
            });
          } else {
            _this.$message({
              message: err.response,
              type: "warning"
            });
          }
        }
      }
    });
    this.uploader.init();
  },
  beforeDestroy() {
    // 离开页面生命周期函数
    this.offline();
    if (this.websocket) {
      this.websocket.close();
      this.websocket.onerror = null;
      this.websocket.onopen = null;
      this.websocket.onmessage = null;
      this.websocket.onclose = null;
      this.websocket = null;
    }
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  },

  methods: {
    send_request() {
      return new Promise(resolve => {
        authPolicy().then(res => {
          resolve(res.data.data);
        });
      });
    },
    get_signature() {
      return new Promise(resolve => {
        this.send_request().then(res => {
          resolve(res);
        });
      });
    },
    random_string(len) {
      len = len || 32;
      const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      const maxPos = chars.length;
      let pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    get_suffix(filename) {
      const pos = filename.lastIndexOf(".");
      this.suffix = "";
      if (pos !== -1) {
        this.suffix = filename.substring(pos);
      }
      return this.suffix;
    },
    calculate_object_name(filename) {
      console.log(this.key);
      console.log(filename);
      this.suffix = this.get_suffix(filename);
      this.g_object_name = this.key + this.random_string(10) + this.suffix;
    },
    set_upload_param(up, filename) {
      this.get_signature().then(res => {
        this.host = res["host"];
        this.policyBase64 = res["policy"];
        this.accessid = res["accessid"];
        this.signature = res["signature"];
        this.expire = parseInt(res["expire"]);
        this.callbackbody = res["callback"];
        this.key = res["dir"];
        this.calculate_object_name(filename);
        let new_multipart_params = {
          key: this.g_object_name,
          policy: this.policyBase64,
          OSSAccessKeyId: this.accessid,
          success_action_status: "200", //让服务端返回200,不然，默认会返回204
          signature: this.signature,
          callbackbody: this.callbackbody
        };
        console.log(new_multipart_params);
        console.log(this.host);
        up.setOption({
          url: this.host,
          multipart_params: new_multipart_params
        });

        up.start();
      });
    },
    offline() {
      kefu_api_offline();
    },
    async getMsgList() {
      // 检查时间是否超过半个月
      let update_time = await localforage.getItem("chat-log-update");
      if (new Date().getTime() - update_time > 15 * 24 * 60 * 60 * 1000) {
        await localforage.setItem("chat-log", []);
      }
      try {
        const res = await get_chat_log({ page: this.page });
        console.log("历史记录");
        console.log(res);
        this.loading = false;
        if (res.data.data && res.data.data.length > 0) {
          let result = res.data.data.filter(item => item.type === "chat-text"||item.type === "user/online");
          result.forEach(item => {
            item.time = dayjs(item.created_at * 1000).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          });
          result.reverse();
          this.page++;
          this.msgList = [...result, ...this.msgList];
          console.log(result);
          // 更新缓存
          await localforage.setItem("chat-log", this.msgList);
          await localforage.setItem("chat-log-update", new Date().getTime());
          if (this.page === 0) this.scrollToBottom();
        } else {
          this.finished = true;
        }
      } catch (e) {
        console.log("getMsgList error", e);
        this.loading = false;
        this.msgList = await localforage.getItem("chat-log");
        this.error = true;
      }
    },
    ossUpload(file, ossToken) {
      let vm = this;

      let formData = new FormData();
      //注意formData里append添加的键的大小写
      console.log(ossToken);
      // formData.append('name', file.file.name) // 文件名称
      // formData.append('key', "uploads/7/202109/"+file.file.name ); //存储在oss的文件路径
      formData.append("key", ossToken.dir + file.file.name); //存储在oss的文件路径

      formData.append("OSSAccessKeyId", ossToken.accessid); //accessKeyId
      formData.append("policy", ossToken.policy); //policy
      formData.append("Signature", ossToken.signature); //签名
      formData.append("callback", ossToken.callback); //回调
      formData.append("success_action_status", 200); //成功后返回的操作码
      formData.append("file", file.file);
      vm.$axios
        .post(ossToken.host, formData, {
          "Content-Type": "multipart/form-data"
        })
        .then(res => {
          console.log("上传成功？", res);
          // this.srcList.push(res.data.resultContent.filename);
        });
    },

    /**
     * 初始化websocket
     */
    initWebSocket() {
      // var websocket = null;
      //判断当前浏览器是否支持WebSocket
      // if ('WebSocket' in window) {
      //   var serviceIp ="www.rougtxijia.com/wss";
      //   this.websocket = new WebSocket("ws://"+serviceIp+"/system/websocket");
      // }else if ('MozWebSocket' in window) {
      //   var serviceIp ="www.rougtxijia.com/wss";
      //   this.websocket = new WebSocket("ws://"+serviceIp+"/system/websocket");
      // }
      // else {
      //   console.log('当前浏览器 Not support websocket');
      //   let that = this;
      //   this.interval = window.setInterval(function(){ //每隔30秒钟发送一次心跳，避免websocket连接因超时而自动断开
      //     that.forgeWebSocket();
      //   },30000);
      // }

      var url = "wss://" + $store.state.app.fwq + "/wss";
      this.websocket = new WebSocket(url);
      let that = this;
      this.interval = window.setInterval(function() {
        //每隔30秒钟发送一次心跳，避免websocket连接因超时而自动断开
        if (that.websocket != null) {
          that.websocketSend(JSON.stringify({ type: "ping" }));
          console.log("发送心跳包：" + JSON.stringify({ type: "ping" }));
        }
      }, 30000);

      //连接发生错误的回调方法
      this.websocket.onerror = this.websocketOnerror;
      //连接成功建立的回调方法
      this.websocket.onopen = this.websocketOnopen;

      //接收到消息的回调方法
      this.websocket.onmessage = this.websocketOnmessage;

      //连接关闭的回调方法
      this.websocket.onclose = this.websocketOnclose;

      this.$router.afterEach(() => {
        if (this.websocket) {
          this.websocket.close();
          this.websocket.onerror = null;
          this.websocket.onopen = null;
          this.websocket.onmessage = null;
          this.websocket.onclose = null;
          this.websocket = null;
        }
      });
    },

    websocketOnopen: function() {
      console.log("WebSocket连接成功");
      kefu_api_online().then(res => {
        console.log("通知客服上线成功", res);
      });

      this.websocketSend(
        JSON.stringify({
          type: "user/start",
          token: $store.state.app.token
        })
      );

      this.websocketSend(JSON.stringify({ type: "success" }));
    },
    websocketOnerror: function() {
      console.log("WebSocket连接发生错误");
      this.reconnect();
    },
    async websocketOnmessage(e) {
      try {
        let data = JSON.parse(e.data); //解析对象
        console.log("-----接收消息-------", data);
        if (data.type === "ping")
          return this.websocket.send(JSON.stringify({ type: "ping" }));
        if (data.type === "success") console.log("login---success");
        if (data.type === "chat-text") {
          data.time = dayjs(data.created_at * 1000).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          this.msgList.push(data);
          await localforage.setItem("chat-log", this.msgList);
          await localforage.setItem("chat-log-update", new Date().getTime());
          this.scrollToBottom();
        }
      } catch (e) {
        console.log(e);
      }
    },
    websocketOnclose: function(e) {
      console.log("connection closed (" + e.code + ")");
      this.reconnect();
    },
    websocketSend(text) {
      // 数据发送
      try {
        console.log("发送中。。。")
        console.log(text)
        this.websocket.send(text);
      } catch (err) {
        console.log("send failed (" + err.code + ")");
      }
    },

    reconnect() {
      var that = this;
      if (that.lockReconnect) return;
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function() {
        console.info("尝试重连...");
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },

    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let vm = this;
      vm.ossUpload(file, vm.ossToken);
    },
    clickInput() {
      let vm = this;
      vm.emojShow = false;
    },

    selectEmoji(emoji) {
      let vm = this;
      // vm.readonly=true;

      console.log("表情选择", emoji);
      let input = document.getElementById("input");
      let startPos = input.selectionStart;
      let endPos = input.selectionEnd;
      let resultText =
        input.value.substring(0, startPos) +
        emoji.data +
        input.value.substring(endPos);
      input.value = resultText;

      input.selectionStart = startPos + emoji.data.length;
      input.selectionEnd = startPos + emoji.data.length;
      this.message = resultText;
      //可以让输入框聚焦 但是不弹出软键盘
      input.focus();
      vm.readonly = true;
      setTimeout(() => {
        vm.readonly = false;
      }, 100);

      // document.activeElement.blur()
    },
    async sendMsg() {
      let vm = this;
      vm.msgList.push({
        from: "from-user",
        type: "chat-text",
        time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        content: vm.message
      });
      vm.scrollToBottom();
      await localforage.setItem("chat-log", this.msgList);
      await localforage.setItem("chat-log-update", new Date().getTime());
      kefu_api_text({ content: vm.message }).then(res => {
        console.log("发送消息成功", res);
        vm.message = "";
        vm.emojShow = false;
      });
    },
    scrollToBottom() {
      this.$nextTick(() => {
        var container = this.$el.querySelector(".msg");
        container.scrollTop = container.scrollHeight;
      });
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
.chat {
  height: 93vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /deep/ .van-field__control {
    font-size: 16px !important;
  }

  /deep/ .emoji-picker {
    width: 100% !important;
  }

  /deep/ .container-search {
    display: none;
  }

  /deep/ .van-uploader__upload {
    width: 100% !important;
    height: 100% !important;

    .van-uploader__input {
      width: 100% !important;
      height: 100% !important;
    }
  }

  /deep/ .van-field__control {
    /*height: 0px!important;*/
    min-height: 20px !important;
    /*height: auto !important;*/
    padding-top: 10px;
  }

  /* background: red; */

  .head {
    height: 42px;
    background: #007aff;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 13px;
    /* font-weight: bold; */
    color: white;
    padding: 6px 8px;

    .back {
      width: 26px;
      height: 26px;
      object-fit: contain;
    }
  }

  .msg {
    flex: 1;
    overflow: auto;
    padding: 20px 20px;
    background: white;

    .item {
      .left {
        margin-top: 26px;
        display: flex;
        flex-direction: row;
        width: 100%;

        .tx {
          width: 33px;
          height: 33px;
          border-radius: 50%;
          background: #f3f6f9;
          display: flex;
          align-items: center;
          justify-content: center;

          .kefu-tx {
            width: 30px;
            height: 30px;
          }
        }

        .right {
          margin-left: 20px;
          height: auto;
          flex: 1;

          .time {
            height: 20px;
            padding-left: 5px;
            color: #007aff;
          }

          .text {
            margin-top: 7px;
            background: #eff3f6;
            border-radius: 10px;
            padding: 12px 7px;
            word-wrap: break-word;
            word-break: break-all;
          }
        }

        .zw {
          width: 12%;
          /* padding-left: 20px; */
        }
      }

      .rt {
        margin-top: 26px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        width: 100%;

        .tx {
          width: 33px;
          height: 33px;
          border-radius: 50%;
        }

        .right {
          margin-right: 10px;
          height: auto;
          flex: 1;

          .time {
            height: 20px;
            padding-left: 5px;
            text-align: right;
            color: #007aff;
          }

          .text {
            margin-top: 7px;
            background: #def0fc;
            border-radius: 10px;
            padding: 13px 7px;
            word-wrap: break-word;
            word-break: break-all;
          }
        }

        .zw {
          width: 13%;
        }
      }
    }
  }

  .input {
    min-height: 33px;
    width: 100%;
    background: #ffffff;
    display: flex;
    align-items: center;
    background: #f7f8fa;

    .bq {
      width: 20px;
      height: 35px;
      margin: 8px 8px;
      object-fit: contain;
    }

    .wj {
      width: 20px;
      height: 35px;
      margin: 8px 8px;
      position: relative;

      .wj-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .wj-up {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 33px;
        height: 33px;
        opacity: 0;
      }

      /deep/ .van-uploader__upload-icon {
        font-size: 30px;
      }
    }

    .dz {
      width: 20px;
      height: 35px;
      margin: 8px 8px;
      object-fit: contain;
    }

    .sr {
      /* background: red; */
      flex: 1;
      padding: 12px 0px;
    }

    .btn {
      width: 60px;
      text-align: center;
    }
  }
  /deep/ .van-cell {
    padding: 0 15px;
    background: #f7f8fa;
  }
}
/* /deep/ .van-field__body textarea{
  font-size: 13px;
} */
</style>

